import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Layout from "components/Layout";
import AdminLayout from "components/admin/AdminLayout";
import AdminProtectedRoute from "components/admin/AdminProtectedRoute";
import NotFound from "pages/NotFound";
import ProductDetail from "./pages/product-detail";
import Contact from "./pages/contact";
import ProductPortfolio from "./pages/product-portfolio";
import AboutUs from "./pages/about-us";
import Homepage from "./pages/homepage";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminProductsList from "./pages/admin/ProductsList";
import AdminProductTypesList from "./pages/admin/ProductTypesList";
import AdminSettings from "./pages/admin/Settings";
import AdminRolesManagement from "./pages/admin/settings/RolesManagement";
import AdminPermissionsManagement from "./pages/admin/settings/PermissionsManagement";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public admin login - no layout */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Admin panel - protected, with sidebar layout */}
          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminLayout />
              </AdminProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="products" element={<AdminProductsList />} />
            <Route path="product-types" element={<AdminProductTypesList />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="settings/roles" element={<AdminRolesManagement />} />
            <Route path="settings/permissions" element={<AdminPermissionsManagement />} />
          </Route>

          {/* Public user-facing app */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Homepage />} />
            <Route path="homepage" element={<Homepage />} />
            <Route path="product-detail" element={<ProductDetail />} />
            <Route path="product-detail/:idOrSlug" element={<ProductDetail />} />
            <Route path="contact" element={<Contact />} />
            <Route path="product-portfolio" element={<ProductPortfolio />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
